import { Model } from '@vuex-orm/core'
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'
import { Grape } from 'aveine-toolbox'

/**
 * Un cepage propose dans le profil de gout de l'app (REDMINE-13839), sur le
 * modele de FeaturedRegion.
 *
 * `color` range le cepage dans son groupe de l'app (rouges, blancs) : le
 * referentiel des cepages n'a pas de couleur.
 */
export default class FeaturedGrape extends Model {
  static entity = 'featured_grapes'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      'grape': this.belongsTo(Grape, 'grape_id'), 'grape_id': this.attr(null),
      'color': this.string(null).nullable(),
      'position': this.number(null).nullable(),
      'published': this.boolean(false),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = ['grape_id']

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
